<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title float-left" v-if="product.id"> Изменить товар</h4>
                        <h4 class="card-title float-left" v-else> Добавить товар</h4>

                        <div class="float-right">
                            <span class="mr-3">Публиковать</span>
                            <toggle-button v-model="product.publish" class="float-right"
                            :labels="{checked: 'да', unchecked: 'нет'}"
                            :color="{checked: '#42A5F5', unchecked: '#B0BEC5'}"
                            :switchColor="{checked: '#1E88E5', unchecked: '#90A4AE'}" :sync="true"/>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>Категория</label>
                                    <v-select v-model="product.category" label="name"
                                            :options="categories"
                                            :filterable="false"
                                            @search="onCategorySearch"
                                            @search:focus="onCategoryFocus()"
                                            @input="onCategoryChoose"
                                            :class="{invalid : $v.product.category.$error}"></v-select>
                                    <div class="red" v-if="$v.product.category.$error">Пожалуйста, выберите категорию</div>
                                </div>
                                <div class="form-group">
                                    <label for="name">Название <span class="red">*</span></label>
                                    <input type="text" class="form-control" id="name" v-model="product.name"
                                        :class="{invalid : $v.product.name.$error}"
                                        @blur="$v.product.name.$touch()">
                                    <div class="red" v-if="$v.product.name.$error">Пожалуйста, введите название</div>
                                </div>
                                <div class="form-group">
                                    <label>СОСТОЯНИЕ <span class="red">*</span></label>
                                    <select class="form-control" v-model="product.technicalConditionOfCar"
                                            :class="{invalid : $v.product.technicalConditionOfCar.$error}"
                                            @change="onChangeTechnicalCondition">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in technicalConditionOfCars" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.product.technicalConditionOfCar.$error">СОСТОЯНИЕ</div>
                                </div>
                                <div class="form-group">
                                    <label>ОБВЕТШАНИЕ <span class="red">*</span></label>
                                    <select class="form-control" v-model="product.dilapidationValueByExpert"
                                            :class="{invalid : $v.product.dilapidationValueByExpert.$error}">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in dilapidationLookupData" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.product.dilapidationValueByExpert.$error">ОБВЕТШАНИЕ</div>
                                </div>
                                <div class="form-group">
                                    <label for="description">Описание</label>
                                    <textarea class="form-control" id="description" v-model="product.description" rows="5"></textarea>
                                </div>
                                <div class="form-group">
                                    <label>Цена <span class="red">*</span></label>
                                    <div class="input-group">
                                        <numeric-input style="width:85%;border-right:1px solid #ccc;" v-model="product.price" :precision="2"
                                            :class="{invalid : $v.product.price.$error}" @blur="$v.product.price.$touch()">
                                        </numeric-input>
                                        <select class="form-control" style="width:15%;font-weight:bold;border-left:1px solid #ccc;"
                                            v-model="product.priceUnit.code">
                                            <option value="UZS">UZS (сум)</option>
                                            <option value="USD">USD ($)</option>
                                            <option value="RUB">RUB (₱)</option>
                                            <option value="EUR">EUR (€)</option>
                                        </select>
                                    </div>
                                    <div class="red" v-if="$v.product.price.$error">Пожалуйста, введите цена</div>
                                </div>
                                <div class="form-group">
                                    <label>Регион</label>
                                    <v-select v-model="product.region" label="name"
                                            :options="regions"
                                            :filterable="false"
                                            @search="onRegionSearch"
                                            @search:focus="onRegionFocus()"></v-select>
                                </div>
                                <div class="form-group">
                                    <label for="productPhotoDropZone">Изображение</label>
                                    <vue-dropzone id="productPhotoDropZone"
                                                          ref="productPhotoDropZone"
                                                          :options="dropZoneOptions"
                                                          @vdropzone-mounted="onDropZoneMounted"
                                                          @vdropzone-upload-progress="onDropZoneProgress"
                                                          @vdropzone-success="onDropZoneSuccess"
                                                          @vdropzone-error="onDropZoneError"
                                                          @vdropzone-removed-file="onDropZoneRemove">
                                            </vue-dropzone>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <h3>Дополнительные параметры</h3>
                                <div class="form-group" v-for="(variation, index) in product.variations" :key="index">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <label for="name">{{variation.label}} <span class="red" v-if="variation.required">*</span></label>
                                        </div>
                                        <div class="col-md-12">
                                            <input type="text" class="form-control" v-model="variation.value" v-if="variation.type === 'text'"
                                                    :class="{invalid : $v.product.variations.$each[index].value.$error}"
                                                    @blur="$v.product.variations.$each[index].value.$touch()"/>
                                            <numeric-input v-model="variation.value" v-if="variation.type === 'integer'"
                                                    :class="{invalid : $v.product.variations.$each[index].value.$error}"
                                                    @blur="$v.product.variations.$each[index].value.$touch()"></numeric-input>
                                            <numeric-input v-model="variation.value" v-if="variation.type === 'decimal'" :precision="2"
                                                    :class="{invalid : $v.product.variations.$each[index].value.$error}"
                                                    @blur="$v.product.variations.$each[index].value.$touch()"></numeric-input>
                                            
                                            <select class="form-control" v-if="variation.type === 'list'"
                                                v-model="variation.value" :style="{color: (variation.value==='' ? '#CCCCCC' : '#000000')}"
                                                    :class="{invalid : $v.product.variations.$each[index].value.$error}">
                                                <option value="" style="color: #CCCCCC">Пожалуйста, выберите</option>
                                                <option :value="item.code" style="color: #000000"
                                                        v-for="item in variation.items" :key="item.code">
                                                    {{item.name}}
                                                </option>
                                            </select>
                                            <treeselect v-if="variation.type === 'multiselect'" :multiple="true" placeholder="Выберите..."
                                                   v-model="variation.values" :options="prepareVariationItems(variation.items)">
                                           </treeselect>
                                           <date-picker v-if="variation.type === 'date'" value-type="format"
                                                        :not-after="disabledAfter" format="DD/MM/YYYY" v-model="variation.value" lang="ru"></date-picker>

                                            <div class="red" v-if="variation.required && $v.product.variations.$each[index].value.$error">
                                                Пожалуйста, введите значение
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-5">
                            <div class="col-md-12 text-center">
                                <button class="btn btn-default" @click="cancel" :disabled="processing">Отменить</button>
                                <button class="btn btn-success ml-3" @click="save" :disabled="processing">Сохранить</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {BASE_API} from './../../axios'
    import {minValue, required, requiredUnless} from 'vuelidate/lib/validators';
    import ToggleButton from 'vue-js-toggle-button/src/Button';
    import DatePicker from 'vue2-datepicker';

    export default {
        name: "ProductEdit",
        components: {
            ToggleButton,
            DatePicker
        },
        data() {
            return {
                processing: false,
                product: {
                    id: null,
                    name: '',
                    description: '',
                    price: 0.0,
                    priceUnit: {
                        code: 'UZS'
                    },
                    publish: true,
                    category: null,
                    region: null,
                    photos: [],
                    variations: [],
                    technicalConditionOfCar: null,
                    dilapidationValueByExpert: null
                },
                categories: [],
                regions: [],
                dropZoneOptions: {
                    url: BASE_API + 'upload/product',
                    maxFiles: 10,
                    resizeWidth: 1000,
                    acceptedFiles: 'image/*',
                    addRemoveLinks: true,
                    headers: { 'Authorization': `Bearer ` + localStorage.getItem('x_token')}
                },
                technicalConditionOfCars: [
                    {key: "New", name: "Янги"},
                    {key: "VeryGood", name: "Жуда яхши"},
                    {key: "Good", name: "Яхши"},
                    {key: "Satisfactory", name: "Қониқарли"},
                    {key: "ConditionallyAvailable", name: "Шартли равишда яроқли"},
                    {key: "Dissatisfied", name: "Қониқарсиз"},
                    {key: "UnusableOrLame", name: "Қўллашга яроқсиз ёки лом"}
                ],
                dilapidationLookupData: [],
                disabledAfter: new Date()
            }
        },
        validations() {
            return {
                product: {
                    name: {
                        required: required
                    },
                    category: {
                        required: required
                    },
                    price: {
                        required: required,
                        minValue: minValue(0.01)
                    },
                    variations: {
                        $each: {
                            value: {
                                required: requiredUnless(vm => {
                                    return !(vm.required);
                                })
                                // minVal: minValue(0.01)
                            }
                        }
                    },
                    technicalConditionOfCar: {
                        required: required
                    },
                    dilapidationValueByExpert: {
                        required: required
                    }
                }
            };
        },
        methods: {
            // variationValueChange(code) {
            //     if (this.$v.product && this.$v.product.variations && this.$v.product.variations[code]) {
            //         this.$v.product.variations[code].$touch();
            //     }
            // },
            prepareVariationItems(items) {
                if (items && items.length > 0) {
                    return items.map((item) => {
                        return {
                            id: item.code,
                            label: item.name
                        }
                    });
                }
                return [];
            },
            cancel() {
                this.$router.push('/product');
            },
            load(id) {
                this.$http.get('product/' + id)
                    .then(res => {
                        res = res.data;
                        this.product = res;
                        this.initPhotos();
                        this.onCategoryChoose();
                        this.onChangeTechnicalCondition();
                    }, err => {
                        console.log(err);
                    });
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                this.product.data = {};
                if (this.product.variations && this.product.variations.length > 0) {
                    this.product.variations.forEach((variation) => {
                        if ((variation.type === 'list' || variation.type === 'long_list')
                            && variation.items && variation.items.length > 0
                            && variation.value && variation.value.length > 0) {
                            variation.valueLabel = null;
                            variation.items.forEach((item) => {
                                if (item.code && item.code === variation.value) {
                                    variation.valueLabel = item.name;
                                }
                            });
                        }
                        if ((variation.type === 'multiselect') && variation.values && variation.values.length > 0) {
                            variation.value = '';
                            variation.valueLabel = '';
                            variation.values.forEach((val) => {
                                if (val && val.length > 0) {
                                    if (variation.valueLabel.length > 0) {
                                        variation.value += ',';
                                        variation.valueLabel += ', ';
                                    }
                                    variation.value += val;

                                    let valLabel = '';
                                    if (variation.items && variation.items.length > 0) {
                                        for (let i=0; i<variation.items.length; i++) {
                                            if (variation.items[i].code === val) {
                                                valLabel = variation.items[i].name;
                                            }
                                        }
                                    }
                                    variation.valueLabel += valLabel;
                                }
                            });
                        }
                    });
                }
                this.$http.post('product', this.product)
                    .then(res => {
                        console.log(res.data);
                        this.$router.push('/product');
                        this.processing = false;
                    }, err => {
                        this.processing = false;
                        console.log(err);
                    });
            },
            initPhotos() {
                if (this.product && this.product.photos && this.product.photos.length > 0
                && this.$refs && this.$refs.productPhotoDropZone) {
                    this.product.photos.forEach((photo) => {
                        if (photo) {
                            this.$refs.productPhotoDropZone.manuallyAddFile(photo, photo.url);
                        }
                    });
                }
            },
            onCategorySearch(searchTxt, loading) {
                loading(true);
                this.$http.post('category/choose', {search: searchTxt})
                    .then(res => {
                        this.categories = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onCategoryFocus () {
                this.$http.post('category/choose', {search: ''})
                    .then(res => {
                        this.categories = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onCategoryChoose () {
                this.$v.product.category.$touch();
                this.product.variations = [];
                if (this.product.category && this.product.category.id && this.product.category.id > 0) {
                    this.$http.get('category/' + this.product.category.id + '/variations/' + (this.product.id ? this.product.id : 0))
                        .then(res => {
                            if (res.data) {
                                this.product.variations = res.data;
                                this.$forceUpdate();
                            }
                        }, err => {
                            console.log(err);
                        });
                }
            },
            onRegionSearch(searchTxt, loading) {
                loading(true);
                this.$http.post('region/choose', {search: searchTxt})
                    .then(res => {
                        this.regions = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionFocus () {
                this.$http.post('region/choose', {search: ''})
                    .then(res => {
                        this.regions = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onDropZoneProgress(file, progress, bytesSent) {
                this.processing = true;
                console.log('dz-progress:' + progress + ':' + bytesSent);
            },
            onDropZoneSuccess(file, response) {
                this.processing = false;
                if (!this.product.photos) {
                    this.product.photos = [];
                }
                this.product.photos.push(response);
                console.log('dz-success');
                console.log(response);
            },
            onDropZoneError() {
                this.processing = false;
                console.log('dz-error');
            },
            onDropZoneRemove(file/*, error, xhr*/) {
                if (this.product.photos && this.product.photos.length > 0) {
                    let photoIndex = null;
                    let hasPhoto = false;
                    for (let i=0; i < this.product.photos.length; i++) {
                        if (this.product.photos[i].id === file.id) {
                            photoIndex = i;
                            hasPhoto = true;
                        }
                    }
                    if (hasPhoto) {
                        this.product.photos.splice(photoIndex, 1);
                    }
                }
                console.log('dz-remove');
            },
            onDropZoneMounted() {
                console.log('dz-mounted');
                this.initPhotos();
            },
            onChangeTechnicalCondition() {
                this.dilapidationLookupData = [];
                if (this.product.technicalConditionOfCar === "New") {
                    this.dilapidationLookupData = [{key: "0", name: "0 %"},{key: "5", name: "5 %"}];
                } else if (this.product.technicalConditionOfCar === "VeryGood") {
                    this.dilapidationLookupData = [{key: "10", name: "10 %"},{key: "15", name: "15 %"}];
                } else if (this.product.technicalConditionOfCar === "Good") {
                    this.dilapidationLookupData = [{key: "20", name: "20 %"}, {key: "25", name: "25 %"},{key: "30", name: "30 %"},{key: "35", name: "35 %"}];
                } else if (this.product.technicalConditionOfCar === "Satisfactory") {
                    this.dilapidationLookupData = [{key: "40", name: "40 %"},{key: "45", name: "45 %"},{key: "50", name: "50 %"}, {key: "55", name: "55 %"},{key: "60", name: "60 %"}];
                } else if (this.product.technicalConditionOfCar === "ConditionallyAvailable") {
                    this.dilapidationLookupData = [{key: "65", name: "65 %"},{key: "70", name: "70 %"},{key: "75", name: "75 %"}, {key: "80", name: "80 %"}];
                } else if (this.product.technicalConditionOfCar === "Dissatisfied") {
                    this.dilapidationLookupData = [{key: "85", name: "85 %"},{key: "90", name: "90 %"}];
                } else {
                    this.dilapidationLookupData = [{key: "97.5", name: "97.5 %"},{key: "100", name: "100 %"}];
                }
            }
        },
        created() {
            const id = this.$route.params.id;
            if (id && id > 0) {
                this.load(id);
            }
        }
    }
</script>

<style scoped>

</style>